export const CLIENT_ID = '1048140097415-nfqf9sn8u84au9rdth2t60di5ljdr6vb.apps.googleusercontent.com';
export const DEVELOPER_KEY = 'AIzaSyC8etEYseXGzrFuWxfYDLns0xLXNynN090';